export const formatListPrice = (
  price: number | null | undefined,
  sellable?: boolean,
  currency?: string | null,
): number | string => {
  if (sellable === false || price === null || price === undefined) {
    return '-';
  }

  return currency ? `${price} ${currency}` : price;
};
